import React from 'react';

export default class FallbackErrorBoundary extends React.Component<{
  fallback: (errorMessage, clearError: () => void) => React.ReactNode;
  children: React.ReactNode;
}> {
  state = {
    hasError: false,
    error: null,
  };

  clearError = () => this.setState({ hasError: false });

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  render() {
    if (this.state.hasError) {
      return this.props.fallback(this.state.error, this.clearError);
    }

    return this.props.children;
  }
}
